import styled from "styled-components";

export const DefaultProfile = styled.div`
    background: ${props => props.color};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
`;

